module.exports = ".link {\n  cursor: pointer;\n  text-align: right !important;\n  color: blue; }\n"